module.exports = __webpack_public_path__ + "img/hide-map.c346f33d.svg";